export interface NotificationHealth {
  pending: number;
  delivery: string;
  retrying?: number;
  blocked?: number;
  sent?: number;
  unbound?: number;
  destinationMismatch?: number;
  lastDeliveredAtMs?: number | null;
  lastWorkerPollAtMs?: number | null;
}

const count = (value: number | undefined) => Number.isFinite(value) && value! >= 0 ? String(Math.trunc(value!)) : "—";

/** Queue readiness is not a delivery receipt, and a receipt is not a read receipt. */
export function notificationHealthSummary(health?: NotificationHealth) {
  const ready = health?.delivery === "READY" && health.pending === 0 &&
    ![health.retrying, health.blocked, health.unbound, health.destinationMismatch].some((value) => (value ?? 0) > 0);
  const receiptMs = health?.lastDeliveredAtMs;
  const receipt = receiptMs === null ? "none recorded"
    : typeof receiptMs === "number" && Number.isFinite(receiptMs) && receiptMs > 0 && receiptMs <= 8.64e15
      ? new Date(receiptMs).toLocaleString()
      : "unavailable";
  return {
    status: ready ? "ACTIVE" : "DEGRADED",
    description: "Queue readiness is not delivery confirmation. Only a confirmed Telegram API receipt counts as sent, not read.",
    telemetry: `${health?.delivery ?? "UNKNOWN"} · queued ${count(health?.pending)} · retrying ${count(health?.retrying)} · blocked ${count(health?.blocked)} · unbound ${count(health?.unbound)} · destination mismatch ${count(health?.destinationMismatch)} · confirmed receipts ${count(health?.sent)}. Last Telegram receipt: ${receipt}.`,
  };
}
